import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { Button, Space, Tabs } from "antd";
import React from "react";

interface HeaderProps {
  viewMode: string;
  setViewMode: (mode: string) => void;
}

export const Header: React.FC<HeaderProps> = ({ viewMode, setViewMode }) => {
  return (
    <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 mb-6">
      <h1 className="text-2xl font-semibold text-gray-900">
        Dispatch Summaries
      </h1>
      <Space className="flex flex-wrap gap-3">
        <Tabs
          activeKey={viewMode}
          onChange={(key) => setViewMode(key)}
          className="bg-white border rounded-lg shadow-sm px-4"
          tabBarStyle={{ margin: 0 }}
          items={[
            {
              key: "daily",
              label: (
                <span
                  className={
                    viewMode === "daily" ? "text-blue-700" : "text-gray-600"
                  }
                >
                  Daily Overview
                </span>
              ),
            },
            {
              key: "weekly",
              label: (
                <span
                  className={
                    viewMode === "weekly" ? "text-blue-700" : "text-gray-600"
                  }
                >
                  Week Planning
                </span>
              ),
            },
            {
              key: "resources",
              label: (
                <span
                  className={
                    viewMode === "resources" ? "text-blue-700" : "text-gray-600"
                  }
                >
                  Resources
                </span>
              ),
            },
            {
              key: "analytics",
              label: (
                <span
                  className={
                    viewMode === "analytics" ? "text-blue-700" : "text-gray-600"
                  }
                >
                  Analytics
                </span>
              ),
            },
          ]}
        />
        <Space>
          <Button
            size="large"
            icon={<PrinterOutlined />}
            className="flex items-center space-x-2 px-4 py-2 border rounded-lg hover:bg-gray-50 bg-white shadow-sm"
          >
            Print
          </Button>
          <Button
            size="large"
            icon={<DownloadOutlined />}
            className="flex items-center space-x-2 px-4 py-2 border rounded-lg hover:bg-gray-50 bg-white shadow-sm"
          >
            Export
          </Button>
        </Space>
      </Space>
    </div>
  );
};
